import { type MultipacksQuantity } from "@product-details/common.types";

export const getQtyForMultipack = (multipacksQuantities: MultipacksQuantity[], option_id: number) => {
  const item = multipacksQuantities.find((item) => item.option_id === option_id);

  return item?.qty ?? 0;
};
